import classNames from 'classnames'
import type { TooltipProps, TooltipContextState } from './types'
import { createContext, useId } from 'react'
import { DisclosureProvider, useDisclosureContext } from '../../hooks'
import React from 'react'
import { Tooltip as BaseTooltip } from '.'

export const TooltipContext = createContext<TooltipContextState>({
  id: '',
  isOpen: false,
  onOpen: () => {},
  onClose: () => {},
})

export const useTooltipContext = () => useDisclosureContext()

export const Tooltip: React.FC<TooltipProps> = ({ children, position }) => {
  const tooltipId = useId()

  const positionClass = {
    top: 'tooltip--top',
    bottom: 'tooltip--bottom',
    left: 'tooltip--left',
    right: 'tooltip--right',
  }[position]

  return (
    <DisclosureProvider>
      <div className={classNames('tooltip', positionClass)}>
        {React.Children.map(children, (child) => {
          if (
            !React.isValidElement(child) ||
            (child.type !== BaseTooltip.Content &&
              child.type !== BaseTooltip.Trigger)
          ) {
            throw new Error(
              '<Tooltip> only accepts <Tooltip.Content> or <Tooltip.Trigger> as children',
            )
          }
          return React.cloneElement(child, { tooltipId })
        })}
      </div>
    </DisclosureProvider>
  )
}
